<span class="dib-id">id: {{ deviceID }} / <app-version></app-version></span>
<button
  *ngIf="showSettings || environment.production === false"
  class="dib-settings"
  mat-icon-button
  type="button"
  (click)="openSettings.emit()"
>
  <mat-icon>settings</mat-icon>
</button>
